export const FEATURE_SECTIONS = [
  {
    id: "callCenter",
    title: "The Pulse of Your Call Center in Real Time",
    description:
      "This page is a dynamic analytics dashboard for monitoring key call center performance metrics. You can track the performance of each agent by indicating their status (active, calling, on break) and the resolution rate, broken down by response time. This is a tool for instant monitoring and workflow management.",
    image: "/images/callCenter.webp",
  },
  {
    id: "clientCard",
    title: "New Client Card: Instant Contact Creation",
    description:
      "This page is a new client card creation interface (CRM), allowing operators to quickly add contacts to the database. Operators can enter full details (first name, last name, date of birth, email, and address), assign a responsible operator, and add work notes. The left side displays the operator's status (Available, Smoking, or Processing Documents), active campaigns for operational management, and a list of organizations for quick access.",
    image: "/images/clientCard.webp",
  },
  {
    id: "analysis",
    title: "AI-powered Conversation Analysis",
    description:
      'This page demonstrates the AI-powered analysis of calls and chats between agents and customers. The central section displays key conversation metrics: the number of positive and negative comments made by the customer, as well as the number of polite and acceptable comments made by the agent, allowing for a quick assessment of the emotional tone. On the right is a detailed AI analysis, concluding that the agent\'s speech was "wordy and difficult to understand" and providing specific recommendations for improving the structure of the conversation to enhance its effectiveness and quality.',
    image: "/images/aiAnalysis.webp",
  },
  {
    id: "archive",
    title: "Call Archive and Agent Activity Details",
    description:
      "This page is the main dashboard for managing call recordings, providing comprehensive information about calls and activity. The main section is a table of call recordings, displaying the date and time, call type (incoming/outgoing), customer or agent number, agent name, event (AGENT COMPLETED, CANCELLED, FORWARDED), and key metrics such as wait time and talk time. Icons for listening, downloading, and additional actions are located next to each recording. This tool is indispensable for auditing and analyzing communications.",
    image: "/images/callArchive.webp",
  },
];
